"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowCDownIcon20Regular = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var BaseIcon_1 = require("../../internal/BaseIcon");
exports.ArrowCDownIcon20Regular = forwardRef_1.forwardRef('ArrowCDownIcon20Regular', function (props, ref) {
    return (react_1.default.createElement(BaseIcon_1.BaseIcon, tslib_1.__assign({ ref: ref, viewBoxSize: 20 }, props),
        react_1.default.createElement("path", { d: "M16.78 6.845a.75.75 0 0 1 0 1.06l-4.836 4.836a2.75 2.75 0 0 1-3.889 0L3.22 7.905a.75.75 0 0 1 1.06-1.06l4.837 4.836a1.25 1.25 0 0 0 1.768 0l4.835-4.836a.75.75 0 0 1 1.061 0Z" })));
});
